export const designTokens = {
  color: {
    background: {
      app: '#0e1210',
      appRgb: '14 18 16',
    },
    surface: {
      page: '#0e1210',
      pageRgb: '14 18 16',
      workbench: '#161c19',
      workbenchRgb: '22 28 25',
      panel: '#1c241f',
      panelRgb: '28 36 31',
      card: '#202a24',
      cardRgb: '32 42 36',
      overlay: '#253029',
      overlayRgb: '37 48 41',
      empty: '#171f1b',
      emptyRgb: '23 31 27',
      selected: '#203429',
      selectedRgb: '32 52 41',
      input: '#151c18',
      inputRgb: '21 28 24',
    },
    border: {
      subtleRgb: '72 88 78',
      defaultRgb: '92 112 100',
      strongRgb: '126 145 134',
    },
    text: {
      primary: '#f1f7f2',
      secondary: '#c8d4cc',
      muted: '#95a79b',
      disabled: '#66756c',
      inverse: '#0e1210',
    },
    repair: {
      green: '#32c46b',
      greenRgb: '50 196 107',
      greenStrong: '#22a957',
      greenStrongRgb: '34 169 87',
      greenDeep: '#167340',
      greenDeepRgb: '22 115 64',
    },
    accent: {
      copper: '#b7894d',
      copperRgb: '183 137 77',
      copperDeep: '#76542d',
      copperDeepRgb: '118 84 45',
      gold: '#d7b35a',
      goldRgb: '215 179 90',
      silver: '#b7c4bd',
      silverRgb: '183 196 189',
      trace: '#5c7064',
      traceRgb: '92 112 100',
    },
    rail: {
      danger: '#ef4444',
      dangerRgb: '239 68 68',
      warning: '#f59e0b',
      warningRgb: '245 158 11',
      success: '#22c55e',
      successRgb: '34 197 94',
      neutral: '#48584e',
      neutralRgb: '72 88 78',
    },
    feedback: {
      error: '#ef4444',
      warning: '#f59e0b',
      success: '#22c55e',
      info: '#38bdf8',
    },
  },
  radius: {
    xs: 4,
    sm: 6,
    md: 8,
    lg: 10,
  },
  spacing: {
    workbenchGap: '0.75rem',
    workbenchGapWide: '0.875rem',
  },
  layout: {
    wideMonitorMax: '1760px',
    wideMonitorMaxExpanded: '1880px',
    queueColumnMin: '22rem',
    queueColumnWideMin: '25rem',
    plannerColumnMin: '36rem',
    plannerColumnWideMin: '56rem',
  },
  action: {
    heightSm: '2rem',
    heightMd: '2.25rem',
    heightLg: '2.5rem',
  },
  motion: {
    quiet: '160ms ease',
    companion: '220ms ease',
    attention: '7.4s ease-in-out',
  },
} as const;

export type DesignTokens = typeof designTokens;
